// Guard
import { privateGuard } from "@/middlewares/guards";

// Layouts
import NavLayout from "../layouts/NavLayout.vue";

// Views
import Logistics from "../views/Logistics.vue";

export default [
  {
    path: "/logistics",
    beforeEnter: privateGuard,
    component: NavLayout,
    children: [
      {
        path: "",
        name: "Logística y almacen",
        component: Logistics,
        meta: {
          title: "Logística y almacen",
        },
      },
    ],
  },
];
